/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const polkadex_chain_about = () => `Polkadex is a decentralized exchange (DEX) built on the Polkadot network. It offers high-performance, low-latency trading with a fully decentralized order book. Users can trade assets across different parachains within the Polkadot ecosystem and external blockchains connected via bridges. Polkadex uses L2 scaling solutions for fast, efficient trading and operates on a non-custodial model, allowing users to retain control of their funds at all times.`
